import { Field as FluentField } from "@fluentui/web-components";
/**
 * Field
 * @summary A Field Custom HTML Element based on FluentField, including style and layout specific attributes.
 *
 * @example
 * ```html
 * <fabric-field label-position="above">
 *   <label slot="label">Label</label>
 *   <input slot="input" />
 *   <span slot="message">Error message</span>
 * </fabric-field>
 * ```
 *
 * @attr {FieldLabelPosition} label-position - The position of the label relative to the input. Possible values are 'above', 'after', 'before'.
 *
 * @prop {FieldLabelPosition} labelPosition - The position of the label relative to the input. Possible values are 'above', 'after', 'before'.
 *
 * @slot label - The slot for the label element.
 * @slot input - The slot for the input element.
 * @slot message - The slot for the message element.
 *
 * @csspart label - The label part of the field component.
 * @csspart input - The input part of the field component.
 * @csspart message - The message part of the field component.
 *
 * @method labelSlotChanged - Updates attributes on the slotted label elements.
 * @method inputChanged - Updates the field's states and label properties when the assigned input changes.
 * @method setValidationStates - Sets the validation states for the field.
 *
 * @extends FluentField
 * @tagname fabric-field
 * @public
 */
export class Field extends FluentField {
}
//# sourceMappingURL=field.js.map